/** @private
 * @deprecated use `isValidString` instead, with typescript type assertion
 */
export const isEmptyString = (input: string | null | undefined): boolean => {
	if (!input) {
		return true;
	}
	if (input.length === 0) {
		return true;
	}
	if (input.replace(/\s/g, '').length === 0) {
		return true;
	}
	return false;
};

export const isValidString = (input: string | null | undefined): input is string => {
	return typeof input === 'string' && input.trim().length > 0;
};
